import React, { useContext, useEffect } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import useProyecto from "../hooks/useProyecto";
import { ModalContext } from "../context/ModalContext";
import { ReportesContext } from "../context/ReportesContext";
import ReporteForm from "../components/reportes/ReporteForm";
import ConfirmDelete from "../components/global/ConfirmDelete";
import { AuthContext } from "../context/AuthContext";

const Reportes = () => {
  const { reportes, setReporte, getReportes, deleteReporte } =
    useContext(ReportesContext);
  const { clearModal, modalComponent } = useContext(ModalContext);
  const { idProyecto } = useProyecto();
  const { user } = useContext(AuthContext);

  // Mirrors the server rule: admins delete any report, others only their own.
  const canDelete = (reporte) =>
    user?.permiso === "admin" ||
    (reporte.idUsuario != null &&
      Number(reporte.idUsuario) === Number(user?.idUsuario));

  useEffect(() => {
    fetchReportes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchReportes = () => getReportes(idProyecto);

  const handleEdit = (reporte) => {
    setReporte(reporte);
    modalComponent("Editar Reporte", <ReporteForm handleCancel={clearModal} handleCallback={fetchReportes} />);
  };

  const handleDelete = (reporte) => {
    modalComponent(
      "Eliminar Reporte",
      <ConfirmDelete
        message={`¿Estás seguro que deseas eliminar el reporte ${reporte.nombre}?`}
        handleDelete={() => deleteReporte(idProyecto, reporte.idReporte, fetchReportes)}
        handleCancel={clearModal}
      />
    );
  };

  const renderReportes = () => {
    if (Array.isArray(reportes)) {
      if(reportes.length === 0) {
        return <p>Aún no hay reportes creados para este proyecto.</p>;
      }
      return (
        <div className="row">
          {reportes.map((reporte) => (
            <div key={reporte.idReporte} className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h5 className="mb-0 text-capitalize">
                      {reporte.nombre || "Sin nombre"}
                    </h5>
                    <span className="badge bg-light text-muted">
                      #{reporte.idReporte}
                    </span>
                  </div>
                  <p className="mb-1 small text-muted">
                    <i className="fa fa-calendar me-2" />
                    {moment(reporte.fecha_inicio).utc().format("DD MMM YYYY")}
                    {" — "}
                    {moment(reporte.fecha_fin).utc().format("DD MMM YYYY")}
                  </p>
                </div>
                <div className="card-footer bg-white border-top-0 text-end">
                  <Link
                    to={`/obra/${idProyecto}/reportes/${reporte.idReporte}`}
                    className="btn btn-sm btn-outline-primary me-2"
                  >
                    <i className="fa fa-eye" />
                  </Link>
                  <button
                    className="btn btn-sm btn-outline-primary me-2"
                    onClick={() => handleEdit(reporte)}
                  >
                    <i className="fa fa-edit" />
                  </button>
                  {canDelete(reporte) && (
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(reporte)}
                    >
                      <i className="fa fa-trash" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      );
    }
    return <div className="spinner-border" />;
  };

  return (
    <div className="container-fluid">
      <div className="row align-items-center mb-3">
        <div className="col-10">
          <h1 className="h2 mb-0">Reportes</h1>
        </div>
        <div className="col-2 text-end">
          <Link to="./generador" className="btn btn-primary">
            <i className="fa fa-plus" />
          </Link>
        </div>
      </div>
      {renderReportes()}
    </div>
  );
};

export default Reportes;
